import script from "./OwnJsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnJsTab.vue?vue&type=script&setup=true&lang=js"

import "./OwnJsTab.vue?vue&type=style&index=0&id=3f4913ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4913ca"]])

export default __exports__